
<template>
  <a-card :title="language['ispforum.personalize']">
      <div style="display: flex; align-items: center;">
          <span>{{ language['ispforum.creativeDisplayAN'] }}</span>
          <a-input v-model="nickName" :maxLength="100" style="width: 300px; margin-left: 8px; margin-right: 8px;" />
          <a-button :loading="loading" type="primary" @click="handleNickNameChange">{{ language['common.confirmButton'] }}</a-button>
      </div>
  </a-card>
</template>

<script>


import { putAction } from '@/api/manageExtend'
export default {
    name: 'Personalise',
    computed: {
        language() {
            return this.$store.getters.language
        },
    },
    data() {
        return {
            nickName: undefined,
            loading: false,
        }
    },
    methods: {

        handleNickNameChange() {
            if(!this.nickName) {
                this.$message.warning(`${this.language['ad.must']}${this.language['ispforum.nickname']}`)
                return
            }
            this.loading = true;
            putAction('/v1/update', {nickname: this.nickName}).then(res => {
                if (res.code === 200) {
                   this.$message.success(this.language['common.editSuccess'])
                } else this.$message.error(res.message)
            }).finally(() => this.loading = false)
        },
    }
}
</script>

<style>


</style>